import { CalculatorContext } from "App";
import { Modal } from "components/Modal";
import { useContext } from "react";

interface IProps {
  isOpen: boolean;
  handleSubmit: () => void;
  handleClose: () => void;
  modalText: string;
}

export const ConfirmModal = ({
  isOpen,
  handleClose,
  handleSubmit,
  modalText,
}: IProps) => {
  const context = useContext(CalculatorContext);

  const { translations } = context!;
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="content-modal">
        <div className="alert-info-modal">
          <h3>{modalText}</h3>
        </div>
      </div>
      <div className="confirm-modal">
        <button type="button" className="close-btn" onClick={handleSubmit}>
          {translations["remove"]}
        </button>
        <button type="button" className="cancel-btn" onClick={handleClose}>
          {translations["cancel"]}
        </button>
      </div>
    </Modal>
  );
};
